import { getData } from '@/store/config/method';

const initialState = () => ({
  dashboard: {},
  status: null,
  message: null,
});
const state = initialState;

const getters = {
  getDashboard: (state) => state.dashboard,
  getMessage: (state) => state.message,
  getStatus: (state) => state.status,
};

const actions = {
  async setDashboardData({ commit, rootState }) {
    try {
      const option = {
        headers: {
          Authorization: 'Bearer ' + rootState.auth.token,
        },
      };
      const response = await getData('api', 'v1/dashboards', option);
      commit('SET_SUM_OF_UPLOADS', response.data.data);
      commit('SET_RESPONSE', response);
    } catch (_) {
      commit('SET_FAILED_LOGIN');
    }
  },
  async setDashboardPublicData({ commit, rootState }) {
    try {
      const option = {
        headers: {
          Authorization: 'Bearer ' + rootState.auth.token,
        },
      };
      const response = await getData('api', 'v1/public/dashboards', option);
      commit('SET_SUM_OF_UPLOADS', response.data.data);
      commit('SET_RESPONSE', response);
    } catch (_) {
      commit('SET_FAILED_LOGIN');
    }
  },

  // async postSumOfUploadsData({ commit, rootState }, payload) {
  //   try {
  //     const option = {
  //       headers: {
  //         Authorization: 'Bearer ' + rootState.auth.token,
  //       },
  //     };
  //     const response = await postData('api', 'v1/brrd', payload, option);
  //     commit('SET_RESPONSE', response);
  //   } catch (_) {
  //     commit('SET_FAILED_LOGIN');
  //   }
  // },

  resetSearch({ commit }) {
    commit('resetState');
  },
};

const mutations = {
  SET_RESPONSE(state, response) {
    state.status = response.data.status;
    state.message = response.data.msg;
  },
  SET_FAILED(state) {
    state.message = 'Network Problem';
    state.status = 0;
  },

  SET_FAILED_MESSAGE(state, error) {
    if (error.status == 400) {
      state.message = 'Nomor KTP atau NIK Anda Salah';
      state.status = 0;
    } else {
      state.message = 'Network Problem';
      state.status = 0;
    }
  },
  SET_FAILED_LOGIN(state) {
    state.message = 'Nomor KTP atau NIK Anda Salah';
    state.status = 0;
  },
  SET_SUM_OF_UPLOADS(state, response) {
    state.dashboard = response;
  },
  resetState(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
